'use strict';

import angular from 'angular';
import './components/buttons';
import './components/datepicker';
import './components/form';
import './components/loading';
import './components/locale';
import './components/modals';
import './components/nav';

/**
 * @ngdoc overview
 * @name commonModule.commonDirectives
 * @description
 * # commonModule.commonDirectives
 * Module for managing the common directives.
 */
const commonDirectives = angular.module('commonModule.commonDirectives',
    [
        'commonModule.buttons',
        'commonModule.dateRangePicker',
        'commonModule.form',
        'commonModule.loading',
        'commonModule.locale',
        'commonModule.modals',
        'commonModule.nav'
    ]);

/**
 * @ngdoc directive
 * @name commonModule.commonDirectives.directive:emptyTable
 * @description
 * Directive for showing "No results" text in the table
 */
commonDirectives.directive('emptyTable', () => {
    return {
        restrict: 'AE',
        replace: true,
        scope: {
            colSpan: '='
        },
        templateUrl: 'views/common/emptyTable.tpl.html'
    };
});

commonDirectives.directive('moduleBox', () => {
    return {
        templateUrl: 'views/common/moduleBox.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.commonDirectives.directive:whoopsBox
 * @description
 * Directive for showing "Whoops!" errors
 */
commonDirectives.directive('whoopsBox', () => {
    return {
        restrict: 'AE',
        replace: true,
        transclude: true,
        scope: {
            msg: '='
        },
        templateUrl: 'views/common/whoopsBox.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.commonDirectives.directive:relinkEvent
 * @description
 * Directive for triggering re-linking event of the specific DOM elements
 */
commonDirectives.directive('relinkEvent', ($rootScope) => {
    return {
        transclude: 'element',
        restrict: 'A',
        link: (scope, element, attr, ctrl, transclude) => {
            let previousContent = null;

            const triggerRelink = () => {
                if (previousContent) {
                    previousContent.remove();
                    previousContent = null;
                }
                transclude((clone) => {
                    element.parent().append(clone);
                    previousContent = clone;
                });
            };

            triggerRelink();
            $rootScope.$on(attr.relinkEvent, triggerRelink);
        }
    };
});

/**
 * @ngdoc directive
 * @name commonModule.commonDirectives.directive:ngEnter
 * @description
 * Directive for submitting on enter
 */
commonDirectives.directive('ngEnter', () => {
    return (scope, element, attrs) => {
        element.bind('keydown keypress', (event) => {
            if (event.which === 13) {
                scope.$apply(() => {
                    scope.$eval(attrs.ngEnter, {'event': event});
                });

                event.preventDefault();
            }
        });
    };
});

/**
 * @ngdoc directive
 * @name commonModule.commonDirectives.directive:ngClickCopy
 * @description
 * Directive for copy text on click
 */
commonDirectives.directive('ngClickCopy', ['$window', '$filter', '$document', 'growl', ($window, $filter, $document, growl) => {
    return {
        restrict: 'A',
        link: (scope, element, attrs) => {
            element.bind('click', () => {
                const body = angular.element($window.document.body);
                const textarea = angular.element('<textarea>');

                textarea.css({
                    position: 'fixed',
                    opacity: '0'
                });
                textarea.val(attrs.value);
                body.append(textarea);
                textarea[0].select();

                try {
                    const successful = $document.execCommand('copy');
                    if (!successful) {
                        throw successful;
                    } else {
                        growl.success('CLIPBOARD.SUCCESS');
                    }
                } catch (err) {
                    $window.prompt($filter('translate')('CLIPBOARD.ERROR'), attrs.value);
                }

                textarea.remove();
            });
        }
    };
}]);

/**
 * @ngdoc directive
 * @name commonModule.commonDirectives.directive:selectOnBlur
 * @description
 * Directive for adding elements to select on blur
 */
commonDirectives.directive('selectOnBlur', () => {
    return {
        require: 'uiSelect',
        link: ($scope, $element, attrs, $select) => {
            const searchInput = $element.querySelectorAll('input.ui-select-search');
            if (searchInput.length !== 1) {
                throw Error('Ups, you destroyed this system :(');
            }

            searchInput.on('blur', () => {
                $scope.$apply(() => {
                    if ($select.activeIndex < 0) {
                        $select.activeIndex = 0;
                    }
                    const item = $select.items[$select.activeIndex];

                    if (item) {
                        if ($select.selected.indexOf(item) < 0) {
                            $select.select(item, false);
                        }
                    }
                });
            });
        }
    };
});

/**
 * @ngdoc directive
 * @name commonModule.commonDirectives.directive:changeOrder
 * @description
 * Directive for change order
 */
commonDirectives.directive('changeOrder', function () {
    return {
        restrict: 'AE',
        scope: {
            data: '=ngModel',
            key: '=key',
            change: '&'
        },
        templateUrl: 'views/common/components/form/changeOrder.tpl.html',
        controller: ['$scope', function ($scope) {

            $scope.upEnable = function () {
                if ($scope.data[$scope.key].order < 0) {
                    return false;
                }
                if ($scope.data[$scope.key - 1]) {
                    return $scope.data[$scope.key - 1].order > 0;
                }

                return false;
            };

            $scope.downEnable = function () {
                if ($scope.data[$scope.key].order < 0) {
                    return false;
                }

                if ($scope.data[$scope.key + 1]) {
                    return $scope.data[$scope.key + 1].order > 0;
                }

                return false;
            };

            $scope.changeOrder = function ($event, key1, key2) {
                $scope.change({
                    $event: $event,
                    key1: key1,
                    key2: key2
                });
            };
        }]
    };
});


/**
 * @ngdoc directive
 * @name commonModule.commonDirectives.directive:changeOrder
 * @description
 * Directive for change order
 */
commonDirectives.directive('changeOrderExtreme', () => {
    return {
        restrict: 'AE',
        scope: {
            data: '=ngModel',
            key: '=key',
            change: '&'
        },
        templateUrl: 'views/common/components/form/changeOrderExtreme.tpl.html',
        controller: ['$scope', ($scope) => {

            $scope.bottomEnable = () => {

                if ($scope.data[$scope.key].order < 0) {
                    return false;
                }
                if ($scope.data[$scope.key + 1]) {
                    return !$scope.data[$scope.key - 1];
                }

                return false;
            };

            $scope.topEnable = () => {

                if ($scope.data[$scope.key].order < 0) {
                    return false;
                }

                if ($scope.data[$scope.key - 1]) {
                    return !$scope.data[$scope.key + 1];
                }

                return false;
            };


            $scope.changeOrderExtreme = ($event, key1, direction) => {
                $scope.change({
                    $event: $event,
                    key1: key1,
                    direction: direction
                });
            };

        }]
    };
});

export default commonDirectives;
